import { getFileIconPath, formatFileSize } from './helpers';
import type { FileAttachment } from '../../types';

interface AttachmentChipsProps {
  attachments: FileAttachment[];
  onRemove(fileId: string): void;
}

export function AttachmentChips({ attachments, onRemove }: AttachmentChipsProps) {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className="attachment-chips">
      {attachments.map((attachment) => (
        <div key={attachment.fileId} className="attachment-chip">
          <svg
            className="attachment-chip-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            dangerouslySetInnerHTML={{ __html: getFileIconPath(attachment.mimeType) }}
          />
          <span className="attachment-chip-name">{attachment.filename}</span>
          <span className="attachment-chip-size">{formatFileSize(attachment.size)}</span>
          <button
            className="attachment-chip-remove"
            type="button"
            onClick={() => onRemove(attachment.fileId)}
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
